import React, {useCallback, useEffect} from 'react'

import MODES from 'constants/MODES'
import {searchService} from 'services'
import ProductsList from 'components/ProductsList'
import getPageSize from 'utils/getPageSize'

const pageSize = getPageSize()

const SearchMain = ({state, handleSearch, searchValue, data, setData}) => {
  useEffect(() => {
    if (state === 'entered') {
      handleSearch(MODES.autocomplete, searchValue)
    }
  }, [state, handleSearch, searchValue, setData])
  
  const handleSearchCustomized = useCallback((...params) => handleSearch(MODES.autocomplete, ...params), [handleSearch])

  return (
    <ProductsList
      data={data}
      loadMoreRequest={page => searchService.prosugcat(searchValue, {take: pageSize, skip: page * pageSize})}
      setData={setData}
      handleSearch={handleSearchCustomized}
      searchValue={searchValue}
    />
  )
}

export default SearchMain
